import { fetchReportAction, fetchReportFailureAction, fetchReportSuccessAction } from "../actions/report.action";
import { ThunkDispatch } from "redux-thunk";
import { IRootState } from "../store";
import { IReportActionTypes } from "../actions/report.action";
import { getTrackier } from "../../services/report";
import { IReportReq } from "../../interfaces/report";

export const fetchReportThunk = (payload: IReportReq) => async (dispatch: ThunkDispatch<IRootState, void, IReportActionTypes>, getState: () => IRootState,) => {
    const { auth } = getState();

    if(auth.token && auth.userId) {
        dispatch(fetchReportAction());
        try {
            const response = await getTrackier(payload, auth.token, auth.userId);

            if(response.data){
                dispatch(fetchReportSuccessAction(response.data));
            } else {
                dispatch(fetchReportFailureAction(response.error));
            }
        } catch (error) {
            dispatch(fetchReportFailureAction("Error fetching report data. Please try again."));
        }
    }
};